// This file was automatically generated from ext.onboarding.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ext.onboarding');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.pageSkeleton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8OBMainFormContainer"><ol class="form-guide-nav-list el8OBProgressSection"></ol><div class="form-guide-container-list"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.errorContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">Sorry!</h1><p class="el8LargeFontSize el8OBMainText">We\'ve experienced an error while processing your application. Unfortunately, you will need to complete the application again. We apologize for the inconvenience!</p><p class="el8LargeFontSize el8OBMainText">Please click on the "Restart Application" button to start the application again. If this problem continues to persist, please contact us directly either via email at ', soy.$$escapeHtml(opt_data.supportEmail), ' or by phone at ', soy.$$escapeHtml(opt_data.supportPhone), '.</p><div class="el8InlineDialogContainer"><button type="button" class="restart-trigger el8AlertButton">Restart Application</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.button = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isPrimary) ? '<div class="el8FloatRight"><button type="' + ((opt_data.isSubmit) ? 'submit' : 'button') + '" class="el8AlertButton" name="' + soy.$$escapeHtml(opt_data.name) + '">' + soy.$$escapeHtml(opt_data.caption) + '</button></div>' : '<button type="' + ((opt_data.isSubmit) ? 'submit' : 'button') + '" class="el8AlertSecondaryButton" name="' + soy.$$escapeHtml(opt_data.name) + '">' + soy.$$escapeHtml(opt_data.caption) + '</button>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.buttons = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8InlineDialogContainer">');
  var buttonList10498 = opt_data.buttons;
  var buttonListLen10498 = buttonList10498.length;
  for (var buttonIndex10498 = 0; buttonIndex10498 < buttonListLen10498; buttonIndex10498++) {
    var buttonData10498 = buttonList10498[buttonIndex10498];
    el8.template.ext.onboarding.button(buttonData10498, output);
  }
  output.append('<span class="tabcatcher" tabindex="0"></span></div>');
  if (!opt_sb) return output.toString();
};
